import { useState } from "react";

import { useMutation } from "../api/hooks";
import { Field, Page, useToast } from "../components/ui";

const AUDIENCES = [
  { value: "all", label: "Everyone" },
  { value: "customers", label: "Customers" },
  { value: "drivers", label: "Drivers" },
  { value: "vendors", label: "Vendor managers" },
] as const;

/** Notification broadcast (02 §16): queued once, fanned out by the worker to the inbox and push. */
export function BroadcastPage() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [audience, setAudience] = useState<(typeof AUDIENCES)[number]["value"]>("customers");
  const [last, setLast] = useState<string | null>(null);
  const { busy, run } = useMutation();
  const toast = useToast();

  async function send() {
    if (!window.confirm(`Send "${title}" to ${AUDIENCES.find((a) => a.value === audience)?.label.toLowerCase()}?`)) return;
    const r = await run<{ broadcast_id: string; audience: string }>("/admin/notifications/broadcast", {
      method: "POST",
      body: { title, body, audience },
    });
    if (r.ok) {
      toast("Broadcast queued");
      setLast(`${title} → ${r.data.audience} (${r.data.broadcast_id.slice(0, 8)}…)`);
      setTitle("");
      setBody("");
    } else toast(r.error, "err");
  }

  return (
    <Page title="Broadcast">
      <div className="grid">
        <section className="card">
          <h2>New notification</h2>
          <div className="form">
            <Field label="Audience">
              <select className="input" value={audience} onChange={(e) => setAudience(e.target.value as typeof audience)}>
                {AUDIENCES.map((a) => (
                  <option key={a.value} value={a.value}>
                    {a.label}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Title">
              <input className="input" maxLength={120} value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Weekend offer" />
            </Field>
            <Field label="Message">
              <textarea className="input" rows={4} maxLength={1000} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Free delivery on all orders above ₹299 this weekend." />
            </Field>
            <div className="form-actions">
              <button type="button" className="btn btn-primary" disabled={busy || !title.trim() || !body.trim()} onClick={send}>
                {busy ? "Sending…" : "Send to audience"}
              </button>
            </div>
            <small className="muted">Every active user of the audience gets an inbox entry and a push notification. The audit log keeps a copy.</small>
            {last && <p className="muted">Last sent: {last}</p>}
          </div>
        </section>
      </div>
    </Page>
  );
}
